var React = require('react');

function LinkedInShare (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21.9951 22.0001V21.9993H22.0001V14.6643C22.0001 11.0759 21.2276 8.31177 17.0326 8.31177C15.0159 8.31177 13.6626 9.41844 13.1101 10.4676H13.0517V8.64677H9.07422V21.9993H13.2159V15.3876C13.2159 13.6468 13.5459 11.9634 15.7017 11.9634C17.8259 11.9634 17.8576 13.9501 17.8576 15.4993V22.0001H21.9951Z","fill":"#262F56","key":0}),React.createElement("path",{"d":"M2.33008 8.64746H6.47675V22H2.33008V8.64746Z","fill":"#262F56","key":1}),React.createElement("path",{"d":"M4.40167 2C3.07583 2 2 3.07583 2 4.40167C2 5.7275 3.07583 6.82583 4.40167 6.82583C5.7275 6.82583 6.80333 5.7275 6.80333 4.40167C6.8025 3.07583 5.72667 2 4.40167 2V2Z","fill":"#262F56","key":2})]);
}

LinkedInShare.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = LinkedInShare;

LinkedInShare.default = LinkedInShare;
